import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IRegistrationToken } from './registrationtokens-model';

@Injectable()
export class RegistrationTokensService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'registrationtokens';

    /** POST */
    public addRegistrationToken(registrationToken: IRegistrationToken): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<boolean>>(
                RegistrationTokensService.URL +
                RegistrationTokensService.ENDPOINT,
                registrationToken
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }
}
